import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type ConstructionSiteData = {
  measurementUuid: string;
  constructionSiteUuids: Array<{ uuid: string, comment?: string }>;
  theBuildingIsMadeOf: 'ceramicBlock' | 'woodenStructure' | 'yTong' | 'silicate' | 'other';
  theBuildingIsMadeOfComment?: string;
  installationElementsUuids: Array<{ uuid: string, comment?: string }>;
  plannedAssemblyTime: string;
  numberOfAssemblyTeams: string;
};

const usePutWindowReplacementConstructionInfo = (
  options?: UseMutationOptions<any, Error, ConstructionSiteData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editConstructionSiteInfo'],
    mutationFn: async (data) => {
      return axiosInstance.put(`/measurement/windows-replacement/installation-info`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych wymiany okien...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-construction-site-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane wymiany okien zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-construction-site-info',
      });
      queryClient.invalidateQueries({ queryKey: ['constructionSiteInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych wymiany okien.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-construction-site-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutWindowReplacementConstructionInfo;
